import React, { useState } from 'react';
import { Box, styled } from '@mui/material';
import MarketTabsNav from './components/MarketTabsNav/MarketTabsNav';
import StockDiscoveryTab from './tabs/StockDiscovery/StockDiscoveryTab';
import IndexFnOTab from './tabs/IndexFnO/IndexFnOTab';
import StocksFnOTab from './tabs/StocksFnO/StocksFnOTab';
import CommoditiesTab from './tabs/Commodities/CommoditiesTab';
import AllIndicesTab from './tabs/AllIndices/AllIndicesTab';
import InternationalTab from './tabs/International/InternationalTab';

const DashboardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  backgroundColor: theme.palette.background.default,
}));

const DashboardRouter = () => {
  const [activeTab, setActiveTab] = useState('international');

  const handleTabChange = (newTabId) => {
    setActiveTab(newTabId);
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'international':
        return <InternationalTab />;
      case 'stock-discovery':
        return <StockDiscoveryTab />;
      case 'index-fno':
        return <IndexFnOTab />;
      case 'stocks-fno':
        return <StocksFnOTab />;
      case 'commodities':
        return <CommoditiesTab />;
      case 'all-indices':
        return <AllIndicesTab />;
      default:
        return <InternationalTab />;
    }
  };

  return (
    <DashboardContainer>
      {/* Top Navigation specific to Dashboard */}
      <MarketTabsNav activeTab={activeTab} onChange={handleTabChange} />
      
      {/* Scrollable Content Area for the Active Tab */}
      <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
        {renderActiveTab()}
      </Box>
    </DashboardContainer>
  );
};

export default DashboardRouter;
